import { useContext } from 'react';

import { TaskDetailContext } from './task-detail-context';

export const useOpenTaskStatistics = () => {
  const { openTaskStatistics } = useContext(TaskDetailContext);

  return openTaskStatistics;
};
